import { createActions, createReducer } from 'reduxsauce'
import Immutable from 'seamless-immutable'
import _ from 'lodash'

export const INITIAL_STATE = Immutable({
  data: {},
  loading: false,
})

const { Types, Creators } = createActions({
  getPickUpPromotions: null,

  setPickUpPromotion: ['data'],
  setPickUpPromotionLoading: ['val'],

  deletePickUpPromotion: ['promotionId'],
  savePickUpPromotion: ['data'],
})

export const setPickUpPromotionReducer = (state, { data }) => state.set('data', data)

export const setPickUpPromotionLoadingReducer = (state, { val }) => state.set('loading', val)

export const deletePickUpPromotionReducer = (state, { promotionId }) =>
  state.set('data', _.omit(state.data, promotionId))

export const savePickUpPromotionReducer = (state, { data }) =>
  state.setIn(['data', data.key], data)

export const pickUpPromotionReducer = createReducer(INITIAL_STATE, {
  [Types.SET_PICK_UP_PROMOTION]: setPickUpPromotionReducer,
  [Types.SET_PICK_UP_PROMOTION_LOADING]: setPickUpPromotionLoadingReducer,
  [Types.SAVE_PICK_UP_PROMOTION]: savePickUpPromotionReducer,
  [Types.DELETE_PICK_UP_PROMOTION]: deletePickUpPromotionReducer,
})

export const PickUpPromotionTypes = Types
export default Creators



// WEBPACK FOOTER //
// ./src/reducers/pickUpPromotionReducer.js